import React from 'react';
import { getDataSession, validarExisteSucursalPrincipal } from 'views/Utils/Common';
import Table from 'components/table/Table';
import { useUIUtils } from 'hooks/useUIUtils';

const List = ({ match }) => {
    const { path } = match;
    const { changeGlobalTitle } = useUIUtils()

    React.useEffect(() => {
        changeGlobalTitle('Pagos realizados', 'Listado de pagos realizados.')
        validarExisteSucursalPrincipal();
    }, [changeGlobalTitle]);

    return (<>
        <div className='container-fluid'>
            <div className='col-md-12'>
                <Table
                    columns={[
                        'Folio',
                        'Monto',
                        'Concepto',
                        'Moneda',
                        'Estado',
                        'Metodo Pago',
                        'Fecha Pago',
                        'Fecha Aprovacion',
                        'Pasarela'
                    ]}
                    rows={[
                        ['text', 'id'],
                        ['moneda', 'monto'],
                        ['text', 'concepto'],
                        ['text', 'moneda'],
                        ['text', 'estatus'],
                        ['text', 'metodo_Pago'],
                        ['text', 'fecha_Pago'],
                        ['text', 'fecha_Pago_Aprovado'],
                        ['text', 'pasarela']
                    ]}
                    /*eliminar = {eliminar}*/
                    path={path}
                    url={`/Pagos/List?empresa_id=${getDataSession('empresa')}`}
                ></Table>
            </div>
        </div>
    </>);
};

export { List };
